import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';

class Loading extends Component {
    render() {
        const { height = '700px', variant = 'primary' } = this.props;

        return (
            <div
                style={{ minHeight: height }}
                className="d-flex justify-content-center align-items-center"
            >
                <Spinner animation="border" role="status" variant={variant}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }
}

export default Loading;
